import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';

import {LightTheme} from 'shared/themes';

import Router from './routes';

export const App = () => {

  return (
    <ThemeProvider theme={LightTheme}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeProvider>
  );
};